module.exports = __webpack_public_path__ + "static/media/showmeasign.ad256e6c.png";